import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {DesignVersion, DesignVersionFilterType} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignVersionsState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {VersionsViewType} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/versions/VersionsView';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./VersionsViewHeader.less');
const cx = classnames.bind(styles);

interface Props
{
    type:VersionsViewType;
}

export const DesignVersionsFilterIcon:{[key:string]:string} = {
    [DesignVersionFilterType.PAGE]: MDIcons.common.Page,
    [DesignVersionFilterType.SHEET]: MDIcons.common.Sheet,

    [DesignVersionFilterType.COMPONENTS]: MDIcons.common.Component,
    [DesignVersionFilterType.POSITIONS]: MDIcons.common.Position,
    [DesignVersionFilterType.NOTES]: MDIcons.common.Note,
    [DesignVersionFilterType.EVENT_BINDINGS]: MDIcons.common.EventBinding,
    [DesignVersionFilterType.PROP_BINDINGS]: MDIcons.common.PropBinding,
    [DesignVersionFilterType.NAMED_RANGES]: MDIcons.common.NamedRange,
    [DesignVersionFilterType.CELLS]: MDIcons.common.Cell,

    [DesignVersionFilterType.ADDED]: MDIcons.common.DiffAdded,
    [DesignVersionFilterType.REMOVED]: MDIcons.common.DiffRemoved,
    [DesignVersionFilterType.CHANGED]: MDIcons.common.DiffChanged,
};

@observer
export class VersionsViewHeader extends React.Component<Props, any>
{
    public render():JSX.Element
    {
        const {type} = this.props;

        if( type === VersionsViewType.DIFF ) return this._renderDiff();
        if( type === VersionsViewType.DETAILS ) return this._renderDetails();
    }

    private _renderDiff():JSX.Element
    {
        const dvc = controllers.ui.designVersions;
        const versionsState = dvc.getState();
        const {versions, selectedVersions} = versionsState;

        const first:DesignVersion = dvc.getVersionById(selectedVersions[0]);
        const second:DesignVersion = dvc.getVersionById(selectedVersions[1]);

        const leftVersion = first.timestamp < second.timestamp ? first : second;
        const rightVersion = first.timestamp < second.timestamp ? second : first;

        return (
            <Column className={cx('header')}>

                <Row className={cx('actions')}>
                    <Row className={cx('left')}>
                        {this._renderFilterBtn(null, 'REPORT')}
                        <div className={cx('separator')} />
                        {this._renderFilterBtn(DesignVersionFilterType.PAGE)}
                        {this._renderFilterBtn(DesignVersionFilterType.SHEET)}
                    </Row>
                    <Row className={cx('center')}>
                        {this._renderFilterBtn(DesignVersionFilterType.COMPONENTS)}
                        {this._renderFilterBtn(DesignVersionFilterType.POSITIONS)}
                        {this._renderFilterBtn(DesignVersionFilterType.NOTES)}
                        {this._renderFilterBtn(DesignVersionFilterType.EVENT_BINDINGS)}
                        {this._renderFilterBtn(DesignVersionFilterType.PROP_BINDINGS)}
                        {this._renderFilterBtn(DesignVersionFilterType.NAMED_RANGES)}
                        {this._renderFilterBtn(DesignVersionFilterType.CELLS)}
                    </Row>
                    <Row className={cx('right')}>
                        {this._renderFilterBtn(DesignVersionFilterType.ADDED)}
                        {this._renderFilterBtn(DesignVersionFilterType.REMOVED)}
                        {this._renderFilterBtn(DesignVersionFilterType.CHANGED)}
                    </Row>
                </Row>

                <Row className={cx('subHeader')}>

                    <Row className={cx('side', 'left')}>
                        {this._renderName(leftVersion)}
                    </Row>

                    <Row className={cx('side', 'right')}>
                        {this._renderName(rightVersion)}
                    </Row>

                </Row>

            </Column>
        );
    }

    private _renderDetails():JSX.Element
    {
        const dvc = controllers.ui.designVersions;
        const versionsState = dvc.getState();
        const {versions, selectedVersions} = versionsState;

        const version:DesignVersion = dvc.getVersionById(selectedVersions[0]);

        return (
            <Column className={cx('header')}>

                <Row className={cx('actions')}>
                    {/*details header*/}
                </Row>

                <Row className={cx('subHeader', 'details')}>
                    {this._renderName(version)}
                </Row>

            </Column>
        );
    }

    private _renderName(version:DesignVersion):JSX.Element
    {
        return (
            <Row>
                {version.isCurrent && <span dangerouslySetInnerHTML={{__html: '&lt;&nbsp;'}} />}
                {version.name}
                {version.isCurrent && <span dangerouslySetInnerHTML={{__html: '&nbsp;&gt;'}} />}
            </Row>
        );
    }

    private _renderFilterBtn(filterName:DesignVersionFilterType, text?:string):JSX.Element
    {
        const isSelected = controllers.ui.designVersions.getFilterState(filterName);

        const onClick = filterName
            ? () => this._onClickFilterBtn(filterName)
            : () => this._onClickReportBtn();

        const iconName = filterName ? DesignVersionsFilterIcon[filterName] : MDIcons.common.Report;

        const iconAndText = !!text;

        return (
            <Row
                className={cx('btn', {isSelected, iconAndText})}
                onClick={onClick}
            >
                <MDIcon
                    className={cx('icon')}
                    name={iconName}
                    // size={MDIconSize.medium20}
                />
                {text}
            </Row>
        );
    }

    private _onClickFilterBtn(filterName:DesignVersionFilterType):void
    {
        controllers.ui.designVersions.toggleFilter(filterName);
    }

    private _onClickReportBtn():void
    {
    }
}
